import type { GradeProgressApiResponse } from "@ts/interfaces/progress/api/gradeProgressApiInterface";
import type { CompletionStatus } from "@ts/enums/CompletionStatus";

/**
 * Flips one lesson's status in a progress payload. lessons is keyed by
 * usage_key. Roll-up counts are left to the next lazy refetch — see
 * useGradeProgress.
 */
export function applyLessonStatus(
  progress: GradeProgressApiResponse,
  usageKey: string,
  status: CompletionStatus
): GradeProgressApiResponse {
  const current = progress.lessons[usageKey];
  if (!current || current.status === status) return progress;
  return {
    ...progress,
    lessons: { ...progress.lessons, [usageKey]: { ...current, status } }
  };
}
